// extracted by mini-css-extract-plugin
export default {"Cart":"Wishlist_Cart__Hpklr","detail":"Wishlist_detail__XBk2D"};